// gate-approved-journal-event.ts — 06k C8 (E36). Tách khỏi
// gate-approval-directive-processing.ts (file đó ở trần 200 dòng): sự kiện
// journal `gate_approved` cho một directive approve đã áp. Directive người ⇒
// đúng 4 field như 3.37 (golden I1 0 đổi); directive `chat_delegated` ⇒ thêm
// `source` + `rationale` (che known-values lần nữa lúc ghi journal).
import { randomUUID } from "node:crypto";
import { CHAT_DELEGATED_SOURCE } from "./chat-delegated-attribution.js";
import { redactDecisionText } from "./decision-policy-journal-events.js";
import type { MissionCommitInput } from "./mission-store.js";
import type { Directive } from "./schemas/directive-schema.js";

export function gateApprovedJournalEntry(
  directive: Directive,
  gate: string,
  requestId: string,
  input: { delegatedG3Scope?: { secretValues: readonly string[] } },
): MissionCommitInput {
  const rationale = directive.payload.rationale;
  const delegated =
    directive.source === CHAT_DELEGATED_SOURCE
      ? {
          source: CHAT_DELEGATED_SOURCE,
          ...(typeof rationale === "string"
            ? {
                rationale: redactDecisionText(
                  rationale,
                  input.delegatedG3Scope?.secretValues ?? [],
                ),
              }
            : {}),
        }
      : {};
  return {
    event_id: randomUUID(),
    delta: {
      kind: "gate_approved",
      gate,
      request_id: requestId,
      actor_id: directive.actor_id,
      ...delegated,
    },
  };
}
